import { render, staticRenderFns } from "./SuppliersTabs.vue?vue&type=template&id=7975c5c8&"
import script from "./SuppliersTabs.vue?vue&type=script&lang=js&"
export * from "./SuppliersTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports